// WE USE VITE JS instead of importmap
import "./controllers";
import "./channels";
import "@hotwired/turbo-rails"
// DAISY
//import  "daisy"
// charting
import "apexcharts"
import ApexCharts from "apexcharts"
import ahoy from 'ahoy.js';
window.ApexCharts = ApexCharts
window.ahoy = ahoy
